import React from 'react';
import { Link } from 'react-router-dom';

function Privacy() {
  return (
    <>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>Privacy Policy</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="privacy-policy page-section-ptb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span className="text-center">Protecting your personal information</span>
                <h2>Privacy Policy</h2>
                <div className="separator"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <p>At The Key Valet Parking Service, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our valet parking services.</p>
              <p>By using our services, you consent to the data practices described in this policy. We comply with all applicable data protection laws and regulations in Qatar.</p>

              <h5 className="text-red">Information We Collect</h5>
              <p>We collect various types of information in connection with the services we provide, including:</p>
              <ul className="list-style-1">
                <li><i className="fa fa-angle-right"></i> Personal identification information (name, phone number, email address)</li>
                <li><i className="fa fa-angle-right"></i> Vehicle information (make, model, license plate number, color)</li>
                <li><i className="fa fa-angle-right"></i> Payment information (credit/debit card details for transaction processing)</li>
                <li><i className="fa fa-angle-right"></i> Service usage data (date, time, location of service)</li>
                <li><i className="fa fa-angle-right"></i> Communication records (inquiries, feedback, complaints)</li>
              </ul>

              <h5 className="text-red">How We Use Your Information</h5>
              <p>We use the collected information for the following purposes:</p>
              <ul className="list-style-1">
                <li><i className="fa fa-angle-right"></i> To provide and maintain our valet parking services</li>
                <li><i className="fa fa-angle-right"></i> To process payments and prevent fraudulent transactions</li>
                <li><i className="fa fa-angle-right"></i> To communicate with you about your service requests and bookings</li>
                <li><i className="fa fa-angle-right"></i> To improve our services and customer experience</li>
                <li><i className="fa fa-angle-right"></i> To send promotional materials and special offers (with your consent)</li>
                <li><i className="fa fa-angle-right"></i> To comply with legal obligations and resolve disputes</li>
              </ul>

              <h5 className="text-red">Data Security</h5>
              <p>We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. These measures include encryption, secure servers, access controls, and regular security assessments. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

              <h5 className="text-red">Information Sharing and Disclosure</h5>
              <p>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
              <ul className="list-style-1">
                <li><i className="fa fa-angle-right"></i> With service providers who assist us in operating our business (e.g., payment processors)</li>
                <li><i className="fa fa-angle-right"></i> When required by law or to respond to legal processes</li>
                <li><i className="fa fa-angle-right"></i> To protect our rights, property, or safety, or that of our customers or others</li>
                <li><i className="fa fa-angle-right"></i> With your explicit consent</li>
              </ul>

              <h5 className="text-red">Data Retention</h5>
              <p>We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When we no longer need your information, we will securely delete or anonymize it.</p>

              <h5 className="text-red">Your Rights</h5>
              <p>You have the right to:</p>
              <ul className="list-style-1">
                <li><i className="fa fa-angle-right"></i> Access and review your personal information</li>
                <li><i className="fa fa-angle-right"></i> Request correction of inaccurate or incomplete information</li>
                <li><i className="fa fa-angle-right"></i> Request deletion of your personal information</li>
                <li><i className="fa fa-angle-right"></i> Object to or restrict the processing of your information</li>
                <li><i className="fa fa-angle-right"></i> Withdraw consent for marketing communications</li>
              </ul>

              <h5 className="text-red">Cookies and Tracking Technologies</h5>
              <p>Our website may use cookies and similar tracking technologies to enhance user experience, analyze website traffic, and for marketing purposes. You can control cookie settings through your browser preferences.</p>

              <h5 className="text-red">Changes to This Privacy Policy</h5>
              <p>We may update this Privacy Policy from time to time to reflect changes in our practices or for legal, regulatory, or operational reasons. We will notify you of any material changes by posting the new Privacy Policy on our website with an updated effective date.</p>

              <h5 className="text-red">Contact Us</h5>
              <p className="mb-0">If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at:<br/>
              <strong>The Key Valet Parking Service</strong><br/>
              Office No. 102, Building 35, Al Mirqab Mall, Zone 38, Qatar<br/>
              Phone: +974 3377 7441<br/>
              Email: <a href="mailto:info@valetparking.qa">info@valetparking.qa</a></p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Privacy;
